<template>
  <div class="account">
    <el-form :model="searchForm">
      <el-form-item label="平台名称：">
        <y-shop-by-platform
          :shopData="shopData"
          @change="shopChange"
        ></y-shop-by-platform>
      </el-form-item>
    </el-form>
    <div>
      <y-table
        :tableData="tableData"
        :tableInfo="tableInfoNew"
        :loading="talbeLoading"
        :pageInfo="pageInfo"
        :autoMaxHeight="false"
        @handlePage="handlePage"
      >
        <template #platform="scope">
          <span> {{ $getPlatformNameByValue(scope.row.platform) }} </span>
        </template>
        <template #mobile="scope">
          <span> {{ $maskPhoneNumber(scope.row.mobile) }} </span>
        </template>
        <template #activeStatus="scope">
          <span> {{ scope.row.activeStatus == 1 ? "未激活" : scope.row.activeStatus == 2 ? "已激活" : "-" }} </span>
        </template>
        <template #operation="scope">
          <y-button type="blueText" @click="handleDetail(scope.row)" v-if="scope.row.yunqueOneId">客户视图</y-button>
        </template>
      </y-table>
    </div>
  </div>
</template>

<script>
import { getMemberSellerManageDetail, getYunzhouSystemUrl } from "@/api/memberMessageSystem";
import store from '@/store'
export default {
  props: {
    memberId: {
      type: String,
    },
    shopData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchForm: {
        platform: "",
        sellerManageId: "",
      },
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      talbeLoading: false,
      tableData: [],
      tableInfo: [
        {
          prop: "scoresUpdateRecordId",
          label: "平台名称",
          slot: "platform",
        },
        {
          prop: "sellerManageName",
          label: "店铺名称",
        },
        {
          prop: "platformUserId",
          label: "用户平台ID",
        },
        {
          label: "淘宝平台会员激活状态",
          prop: "activeStatus",
          slot: "activeStatus",
        },
        {
          label: "淘宝平台会员激活时间",
          prop: "activeTime",
        },
        {
          prop: "registerMinTime",
          label: "首次入会时间",
        },
        {
          prop: "registerMaxTime",
          label: "最近一次入会时间",
        },
        {
          prop: "quitMinTime",
          label: "首次退会时间",
        },
        {
          prop: "quitMaxTime",
          label: "最近一次退会时间",
        },
        {
          prop: "mobile",
          label: "最新手机号码",
          slot: "mobile",
        },
      ],
      yunqueFlag: false,
    };
  },
  created() {
    this.getList();
    this.yunqueFlag = store.getters.sellerData && store.getters.sellerData.yunqueFlag;
    if(this.yunqueFlag){
      this.tableInfo.push({
        prop: "operation",
        label: "操作",
        slot: "operation",
      })
    }
  },
  computed: {
    tableInfoNew(){
      if(this.shopData && this.shopData.length > 0 && this.shopData.some((item) => item.platform == 1)){
        return this.tableInfo
      }else{
        return this.tableInfo.filter((item) => item.prop != "activeStatus" && item.prop != "activeTime");
      }
    }
  },
  methods: {
    shopChange(platform, shop) {
      this.searchForm.platform = platform;
      this.searchForm.sellerManageId = shop;
      this.getList()
    },
    getList() {
      const query = {
        current: this.pageInfo.pageNum,
        size: this.pageInfo.pageSize,
        memberId: this.memberId,
      };
      if (this.searchForm.platform) {
        query.platform = this.searchForm.platform;
      }
      if (this.searchForm.sellerManageId) {
        query.sellerManageId = this.searchForm.sellerManageId;
      }
      getMemberSellerManageDetail(query).then((res) => {
        this.tableData = res.data.dataList ? res.data.dataList : [];
        this.pageInfo.total = res.data.pageInfo ? res.data.pageInfo.totalL : 0;
      });
    },
    handlePage(page) {
      this.pageInfo.pageNum = page.pageNum;
      this.pageInfo.pageSize = page.pageSize;
      this.getList();
    },
    handleDetail(row){
      getYunzhouSystemUrl({
        redirectUrl: `/customer/group/groupList?yunqueOneId=${row.yunqueOneId}&page=view`,
        platformCode: "YQ",
      }).then((res) => {
        window.open(res.data, "_blank");
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.account {
  margin-bottom: 32px;
}
</style>